import { render, staticRenderFns } from "./EditoPopin.vue?vue&type=template&id=7472638f"
import script from "./EditoPopin.vue?vue&type=script&lang=ts"
export * from "./EditoPopin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports